import { useState } from 'react'

import { Box, Button, InputAdornment, Popover, Slider, Stack, TextField } from '@mui/material'
import { ArrowDropDown } from "@mui/icons-material"

import { MAX_POSSIBLE_SCORE, MIN_POSSIBLE_SCORE, SCORE_RANGE_STEP } from './constants'
import { CNPJAutocomplete } from '../../autocompletes'


const CompanyCustomersFilters = ({ setFilter }) => {

    const [ anchorEl, setAnchorEl ] = useState(null)
    const handlePopoverButtonClick = (event) => { setAnchorEl(event.currentTarget) }
    const handlePopoverClose = () => { setAnchorEl(null) }

    const isPopoverOpen = Boolean(anchorEl)
    const popOverId = isPopoverOpen ? 'score-range-popover' : undefined

    const [ [ minScore, maxScore ], setScoreRange ] = useState([MIN_POSSIBLE_SCORE, MAX_POSSIBLE_SCORE])
    const [ document, setDocument ] = useState(undefined)
    const [ seller_code, setSellerCode ] = useState(undefined)

    const handleScoreRangeChange = (_, [min, max]) => {
        if (max - min >= SCORE_RANGE_STEP) {
            setScoreRange([min, max])
        }
    }

    const scoreRangeBottomMarks = [
        { value: MIN_POSSIBLE_SCORE, label: `${MIN_POSSIBLE_SCORE}` },
        { value: MAX_POSSIBLE_SCORE, label: `${MAX_POSSIBLE_SCORE}` }
    ]

    return (
        <Stack
            direction='row'
            gap={2} sx={{ width: '100%' }}
            component='form'
            onSubmit={(e) => {
                e.preventDefault()
                setFilter({
                    document,
                    seller_code,
                    minScore,
                    maxScore
                })
            }}
        >

            <CNPJAutocomplete
                onChange={(_, newValue) => {
                    setDocument(newValue || null)
                }}
                name="document"
                label='Buscar CNPJ'
                fullWidth
                value={document ?? null}
                placeholder='Digite o CNPJ que deseja buscar'
            />


            <TextField
                name="seller_code"
                variant="outlined"
                placeholder='Digite o código do vendedor que deseja buscar'
                label='Buscar Vendedor'
                fullWidth
                value={seller_code ?? ''}
                onChange={(e) => setSellerCode(e.target.value || null)}
            />

            <TextField
                fullWidth
                component='div'
                placeholder='Selecione a Faixa'
                label='Faixa de Score'
                variant='outlined'

                aria-describedby={popOverId}
                value={
                    (minScore !== MIN_POSSIBLE_SCORE || maxScore !== MAX_POSSIBLE_SCORE)
                    ? `${minScore} - ${maxScore}`
                    : ''
                }
                onClick={handlePopoverButtonClick}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <ArrowDropDown />
                        </InputAdornment>
                    ),
                }}
                focused={isPopoverOpen}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        cursor: "pointer",
                    },
                    "& .MuiOutlinedInput-input": {
                        cursor: "pointer",
                        caretColor: "transparent"
                    }
                }}
            />

            <Stack direction='row' gap={2} sx={{ width: '100%' }} alignItems='center' >
                <Button
                    variant='contained'
                    type='submit'
                    sx={{ textTransform: 'none', flex: 1 }}
                >
                    APLICAR FILTRO
                </Button>

                <Button
                    variant='outlined'
                    type='button'
                    onClick={() => {
                        setDocument(undefined)
                        setSellerCode(undefined)
                        setScoreRange([ MIN_POSSIBLE_SCORE, MAX_POSSIBLE_SCORE ])
                        setFilter({
                            document: null,
                            seller_code: null,
                            minScore: MIN_POSSIBLE_SCORE,
                            maxScore: MAX_POSSIBLE_SCORE
                        })
                    }}
                >
                    Limpar
                </Button>
            </Stack>

            <Popover
                id={popOverId}
                open={isPopoverOpen}
                anchorEl={anchorEl}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >

                <Box sx={{ paddingX: 4, paddingTop: 5, paddingBottom: 2 }}>
                    <Slider
                        getAriaLabel={() => 'Faixa de Score'}
                        value={[ minScore, maxScore ]}
                        onChange={handleScoreRangeChange}
                        min={MIN_POSSIBLE_SCORE}
                        max={MAX_POSSIBLE_SCORE}
                        step={SCORE_RANGE_STEP}
                        sx={{
                            minWidth: "200px",
                            '& .MuiSlider-valueLabel': {
                                color: 'rgb(30, 30, 30)',
                                backgroundColor: 'rgba(0, 0, 0, 0)'
                            },
                        }}
                        disableSwap
                        valueLabelDisplay='on'
                        marks={scoreRangeBottomMarks}
                    />
                </Box>
            </Popover>

        </Stack>
    )
}

export default CompanyCustomersFilters

